// Salesforce integration scope API values and related endpoint identifiers.

export const INTEGRATION_SCOPE_MODES = {
  ORGANIZATION: 'organization',
  USER_GROUP: 'user_group',
  NONE: 'none',
}

/** RTK Query endpoint name for the Salesforce account (api inject + cache patches). */
export const FETCH_SALESFORCE_ACCOUNT = 'fetchSalesforceAccount'

/** Integration scopes CRUD API used for Salesforce group / org sync configuration. */
export const INTEGRATION_SCOPES_API_PATH = '/api/integrations/integration_scopes'
